import { parseISO } from 'date-fns';

export type OpenPunchLabelInput = {
  shiftEndTime?: string | null;
  actualIn?: string | null;
};

/** Mirrors Timecards page label rules for open-punch Actual Out display. */
export function getOpenPunchOutLabel(
  input: OpenPunchLabelInput,
  now: Date = new Date()
): 'InProgress' | 'Not clocked out' {
  if (input.shiftEndTime) {
    const shiftEnd = parseISO(input.shiftEndTime);
    return now < shiftEnd ? 'InProgress' : 'Not clocked out';
  }

  if (input.actualIn) {
    const clockIn = parseISO(input.actualIn);
    const hours = (now.getTime() - clockIn.getTime()) / (1000 * 60 * 60);
    return hours < 4 ? 'InProgress' : 'Not clocked out';
  }

  return 'InProgress';
}
